import { ShoppingCart, Menu, X } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '@/context/CartContext';
import CartDrawer from './CartDrawer';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { setIsCartOpen, getCartCount } = useCart();
  const cartCount = getCartCount();

  return (
    <>
      <motion.nav 
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        className="fixed top-0 left-0 right-0 z-50 glassmorphism"
        data-testid="navbar"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center" data-testid="logo-link">
              <h1 className="font-heading text-2xl font-bold tracking-tight text-primary text-glow">
                DON'T <span className="text-white">DISTURB</span>
              </h1>
            </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <Link 
                to="/" 
                className="text-sm uppercase tracking-wider text-zinc-400 hover:text-white transition-colors"
                data-testid="nav-home"
              >
                Home
              </Link>
              <Link 
                to="/catalog" 
                className="text-sm uppercase tracking-wider text-zinc-400 hover:text-white transition-colors"
                data-testid="nav-catalog"
              >
                Catálogo
              </Link>
            </div>

            {/* Cart Button */}
            <div className="flex items-center space-x-4">
              <button
                onClick={() => setIsCartOpen(true)}
                className="relative p-2 text-white hover:text-primary transition-colors"
                data-testid="cart-button"
              >
                <ShoppingCart className="h-6 w-6" />
                {cartCount > 0 && (
                  <motion.span
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    className="absolute -top-1 -right-1 bg-primary text-black text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center"
                    data-testid="cart-count"
                  >
                    {cartCount}
                  </motion.span>
                )}
              </button>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="md:hidden p-2 text-white"
                data-testid="mobile-menu-button"
              >
                {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              className="md:hidden border-t border-white/10"
              data-testid="mobile-menu"
            >
              <div className="px-4 py-4 space-y-3">
                <Link
                  to="/"
                  className="block text-sm uppercase tracking-wider text-zinc-400 hover:text-white transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid="mobile-nav-home"
                >
                  Home
                </Link>
                <Link
                  to="/catalog"
                  className="block text-sm uppercase tracking-wider text-zinc-400 hover:text-white transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid="mobile-nav-catalog"
                >
                  Catálogo
                </Link>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.nav>

      <CartDrawer />
    </>
  );
};

export default Navbar;